import { observer } from "mobx-react-lite";
import React from "react";
import {
  useCourtBookingStore,
  useSelectCircleStore,
} from "../../stores/StoreContext";
import { BottomUnderlineView } from "../bottomUnderlineView/BottomUnderlineView";
import { Colors } from "../../utils/colors";
import {
  PLAYER_PLACEHOLDER_HEIGHT,
  PLAYER_PLACEHOLDER_WIDTH,
} from "../../utils/data";
import { GuestPlayerCard } from "../guestPlayerCard/GuestPlayerCard";
import { TCText } from "../TCText/TCText";

type props = {};

export const GuestPlayersList: React.FC<props> = observer(() => {
  const selectCircleStore = useSelectCircleStore();
  const courtBookingStore = useCourtBookingStore();
  const guestPlayerCount =
    courtBookingStore.totalPlayersToSelect -
    selectCircleStore.selectedPlayers.length;

  return selectCircleStore.selectedPlayers.length <
    courtBookingStore.totalPlayersToSelect ? (
    <div
      style={{
        justifyContent: "center",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        marginTop: 20,
      }}>
      <BottomUnderlineView
        borderRadius={20}
        borderWidth={2}
        borderColor={Colors.gold}
        width={PLAYER_PLACEHOLDER_WIDTH * guestPlayerCount}
        height={PLAYER_PLACEHOLDER_HEIGHT}>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "stretch",
            justifyContent: "center",
            gap: 5,
            height: "100%",
          }}>
          {Array.from({ length: guestPlayerCount }, (_, index) => index).map(
            (v) => (
              <GuestPlayerCard key={v} />
            )
          )}
        </div>
      </BottomUnderlineView>
      <TCText
        value={`Unsecured player${guestPlayerCount !== 1 ? "s" : ""}`}
        style={{
          fontWeight: 500,
          fontSize: 8,
          color: "white",
          // marginTop: 2,
          textAlign: "center",
        }}
      />
    </div>
  ) : null;
});
